import { Component, ElementRef, Inject, OnDestroy } from '@angular/core';

import { DesignStepService
       } from 'collage-designer/design-step/design-step.service';
import { PlaceholderType
       } from 'collage-designer/stage/placeholder/placeholder';
import { PlaceholderService
       } from 'collage-designer/stage/placeholder/placeholder.service';
import { TextPlaceholder
       } from 'collage-designer/stage/placeholder/text-placeholder';
import { ProductService } from 'core/product/product.service';
import { EventTrackingService } from 'core/tracking/event-tracking.service';
import { Subscription } from 'rxjs';
import { ToolboxComponent } from '../toolbox.component';
import { ToolboxService } from '../toolbox.service';

@Component({
    selector: 'text-edit-toolbox',
    templateUrl: './text-edit-toolbox.component.html',
    styleUrls: [
        './text-edit-toolbox.component.scss', '../toolbox.component.scss'],
    standalone: false
})
export class TextEditToolboxComponent extends ToolboxComponent
    implements OnDestroy
{
  private static readonly ICONS: Array<string> = [
      'empty-text', 'text-add', 'text-edit', 'text-delete'];

  protected name: string = 'TextEditToolbox';

  private subscriptions: Subscription = new Subscription();

  constructor(
      private elRef: ElementRef,
      @Inject(ToolboxService) toolboxService,
      @Inject(ProductService) private productService: ProductService,
      @Inject(PlaceholderService) private placeholderService:
          PlaceholderService,
      @Inject(DesignStepService) private designStepService: DesignStepService,
      @Inject(EventTrackingService) private eventTrackingService:
          EventTrackingService)
  {
    super(toolboxService);
    this.subscriptions.add(
        this.toolboxService.targetChanged.subscribe(
            () => this.respondToToolboxChange()));
  }

  public ngOnDestroy(): void
  {
    this.subscriptions.unsubscribe();
  }

  public get isCreateNewButtonVisible(): boolean
  {
    return this.designStepService.getDesignStepConfig()
      .textPlaceholdersSettings.showCreateNewButton;
  }

  public createNewTextPlaceholder(): void
  {
    this.eventTrackingService.track({
      category: this.productService.getCurrentProduct().id,
      action: 'enter_text',
      label: 'start'
    });
    this.toolboxService.createNewPlaceholder(PlaceholderType.Text);
  }

  public get placeholders(): Array<TextPlaceholder>
  {
    return this.placeholderService.getChangeablePlaceholders()
      .filter(p => p.type === PlaceholderType.Text)
      .map(p => p.placeholder) as TextPlaceholder[];
  }

  private respondToToolboxChange(): void
  {
    const soleTextPlaceholder =
        this.placeholderService.getSoleTextPlaceholder();
    if (!soleTextPlaceholder ||
        this.toolboxService.getActiveToolboxName('design-step') !== this.name ||
        this.toolboxService.getActiveToolboxName('placeholder')
            === 'TextToolbox') {
      return;
    }

    if (this.placeholderService.getFocusedPlaceholder()
        === soleTextPlaceholder) {
      this.btnCloseClick();
    }
    else {
      soleTextPlaceholder.clickEvent();
    }
  }
}
